import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import { PAGE } from "constants/configConstants";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import { unitTypes } from "@Pages/PropertyPage/components/InstalmentSection/utils";
import styles from "./InstalmentTabSection.module.scss";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { AppState } from "@Store/index";
import useStickyScrolling from "hooks/useStickyScrolling";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";

const TabSection = ({
  tabdata = {},
  setActiveTab,
  activeTab,
  isDesktop = false,
}: any) => {
  const [addSticky, setAddSticky] = useState(false);
  const { showAppBanner } = useSelector(({ appData }: AppState) => ({
    showAppBanner: appData.showAppBanner,
  }));
  const tabWrapperRef = useRef(null);
  const isRentInstallment = true;

  useStickyScrolling({
    elRef: tabWrapperRef,
    toggleHeight: 54,
    defaultTop: isDesktop ? 108 : 102,
    hookCondition: [showAppBanner && !isDesktop && addSticky],
    offset: 50,
    scrollCondition: !isDesktop,
  });

  const handleOnScroll = () => {
    const element = document.getElementById("rent_instalments");
    const currOffset = window.pageYOffset;
    if (element?.offsetTop && currOffset - 125 + 48 > element?.offsetTop) {
      setAddSticky(true);
    } else {
      setAddSticky(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleOnScroll);
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
    };
  }, []);
  const { t } = useTranslationHook();

  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
    gtagEventEmitter({
      action: "Instalment_tab_clicked",
      category: PAGE.INVENTORY,
      label: "success",
      tab_clicked: tab,
    });

    const element = document.getElementById("rent_instalments");
    if (!element) return;
    const headerOffset = 54 + 48 - 125; 
    const elementPosition = element?.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };
  return (
    <div
      className={formatClassNames(
        isRentInstallment ? styles.parentContainerV2 : styles.parentContainer,
        addSticky && styles.sticky,
        isDesktop && styles.desktop,
      )}
      ref={tabWrapperRef}
    >
      <div className={formatClassNames(styles.container, isRentInstallment && styles.containerV2)}>
        {Object.keys(tabdata)?.filter(tab => (tabdata as Record<string, any[]>)[tab]?.length > 0).map((tab: string) => (
          <div
            data-testid="property-rent-instalment-tabs"
            className={formatClassNames(
              styles.tab,
              tab === activeTab && styles.active,
              isDesktop && styles.desktop,
              isRentInstallment && styles.tabV2,
            )}
            role="none"
            onClick={() => handleTabClick(tab)}
            key={tab}
          >
            {t(unitTypes[tab])} ({(tabdata as Record<string, any[]>)[tab]?.length})
          </div>
        ))}
      </div>
    </div>
  );
};

export default wrapperHOC(TabSection, {
  componentName: "TabSection-PropertyFiltersSection-InstalmentSection-PropertyPage",
  showForChina: true,
});
